module.exports = __webpack_public_path__ + "static/img/modelCodingRulesManage.f03f3e30.png";